import { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { StellarDatePicker } from './StellarFormControls';

const RANGES = [
  { id: 'today', label: 'Today', getDates: () => { const t = new Date().toISOString().slice(0,10); return { start: t, end: t }; } },
  { id: 'week', label: 'This Week', getDates: () => { const n = new Date(); const s = new Date(n); s.setDate(n.getDate() - n.getDay()); return { start: s.toISOString().slice(0,10), end: new Date(s.getTime() + 6*86400000).toISOString().slice(0,10) }; } },
  { id: 'month', label: 'This Month', getDates: () => { const n = new Date(); return { start: `${n.getFullYear()}-${String(n.getMonth()+1).padStart(2,'0')}-01`, end: new Date(n.getFullYear(), n.getMonth()+1, 0).toISOString().slice(0,10) }; } },
  { id: 'custom', label: 'Custom Range', getDates: () => ({ start: '', end: '' }) },
];

export function DateRangeFilter({ value, onChange, storageKey, className = '' }) {
  const [rangeId, setRangeId] = useState(() => {
    if (storageKey && typeof window !== 'undefined') {
      const saved = localStorage.getItem(`stellar_filter_${storageKey}`);
      if (saved) return saved;
    }
    return value?.rangeId || 'week';
  });
  const [customStart, setCustomStart] = useState(value?.start || '');
  const [customEnd, setCustomEnd] = useState(value?.end || '');

  useEffect(() => {
    const range = RANGES.find(r => r.id === rangeId);
    if (!range) return;
    if (rangeId === 'custom') {
      if (customStart && customEnd) onChange({ rangeId, start: customStart, end: customEnd });
    } else {
      const dates = range.getDates();
      onChange({ rangeId, ...dates });
    }
    if (storageKey) localStorage.setItem(`stellar_filter_${storageKey}`, rangeId);
  }, [rangeId, customStart, customEnd]);

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex bg-foreground/[0.03] rounded-lg p-0.5">
        {RANGES.filter(r => r.id !== 'custom').map(r => (
          <button key={r.id} onClick={() => setRangeId(r.id)} className={`px-2.5 py-1 rounded-md text-[11px] font-medium transition-colors ${rangeId === r.id ? 'bg-gold/15 text-gold' : 'text-muted-foreground/40 hover:text-muted-foreground/60'}`}>
            {r.label}
          </button>
        ))}
        <button onClick={() => setRangeId('custom')} className={`px-2.5 py-1 rounded-md text-[11px] font-medium transition-colors ${rangeId === 'custom' ? 'bg-gold/15 text-gold' : 'text-muted-foreground/40 hover:text-muted-foreground/60'}`}>
          Custom
        </button>
      </div>
      {rangeId === 'custom' && (
        <div className="flex items-center gap-1.5">
          <StellarDatePicker
            value={customStart}
            onChange={setCustomStart}
            placeholder="Start"
            size="sm"
            className="w-32"
            clearable={false}
          />
          <span className="text-[10px] text-muted-foreground/30">to</span>
          <StellarDatePicker
            value={customEnd}
            onChange={setCustomEnd}
            placeholder="End"
            size="sm"
            className="w-32"
            minDate={customStart || undefined}
            clearable={false}
          />
        </div>
      )}
    </div>
  );
}
